import { useState, useEffect } from 'react'
import { api } from '../services/api'

const vazio = {
  placa: '', renavam: '', chassi: '', marca: '', modelo: '',
  marca_modelo: '', ano: '', cor: '', cor_lower: '',
  especie_tipo: 'PASSAGEIRO/AUTOMÓVEL', combustivel: 'FLEX',
  categoria: 'PARTICULAR', municipio: 'CURITIBA/PR',
}

function calcularMarcaModelo(form) {
  return `${(form.marca || '').toUpperCase()}/${(form.modelo || '').toUpperCase()}`
}

function F({ label, children }) {
  return (
    <div className="field">
      {label && <label>{label}</label>}
      {children}
    </div>
  )
}

function FormVeiculo({ dados, onChange, onSubmit, salvando, submitLabel }) {
  const set = k => e => {
    const v = e.target.value
    onChange(prev => {
      const next = { ...prev, [k]: v }
      if (k === 'cor') next.cor_lower = v.charAt(0).toUpperCase() + v.slice(1).toLowerCase()
      if (k === 'marca' || k === 'modelo') next.marca_modelo = calcularMarcaModelo(next)
      return next
    })
  }

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
        <F label="Placa *">
          <input type="text" value={dados.placa} onChange={set('placa')} style={{ textTransform: 'uppercase' }} />
        </F>
        <F label="Renavam *">
          <input type="text" value={dados.renavam} onChange={set('renavam')} />
        </F>
        <F label="Chassi *">
          <input type="text" value={dados.chassi} onChange={set('chassi')} />
        </F>
        <F label="Marca *">
          <input type="text" value={dados.marca} onChange={set('marca')} placeholder="Volkswagen" />
        </F>
        <F label="Modelo *">
          <input type="text" value={dados.modelo} onChange={set('modelo')} placeholder="Voyage 1.0 MEC." />
        </F>
        <F label="Ano *">
          <input type="text" value={dados.ano} onChange={set('ano')} placeholder="2024" />
        </F>
        <F label="Cor *">
          <input type="text" value={dados.cor} onChange={set('cor')} placeholder="Branca" />
        </F>
        <F label="Município">
          <input type="text" value={dados.municipio} onChange={set('municipio')} />
        </F>
        <F label="Combustível">
          <select value={dados.combustivel} onChange={set('combustivel')}>
            {['FLEX', 'ALCO/GASOL', 'GASOLINA', 'ETANOL', 'DIESEL', 'GNV', 'ELÉTRICO'].map(c => (
              <option key={c}>{c}</option>
            ))}
          </select>
        </F>
      </div>
      <button
        onClick={onSubmit}
        disabled={salvando}
        className="btn-amber"
        style={{ marginTop: '16px' }}
      >
        {salvando ? 'Salvando...' : submitLabel}
      </button>
    </>
  )
}

function ModalEditar({ veiculo, onSalvar, onFechar }) {
  const [form, setForm] = useState({ ...veiculo })
  const [salvando, setSalvando] = useState(false)
  const [erro, setErro] = useState('')

  const salvar = async () => {
    setErro('')
    if (!form.placa || !form.renavam || !form.chassi || !form.marca || !form.modelo || !form.ano || !form.cor)
      return setErro('Preencha todos os campos obrigatórios.')
    setSalvando(true)
    try {
      const atualizado = await api.veiculos.atualizar(veiculo.id, {
        ...form,
        placa: form.placa.toUpperCase(),
        cor: form.cor.toUpperCase(),
        cor_lower: form.cor.charAt(0).toUpperCase() + form.cor.slice(1).toLowerCase(),
        marca_modelo: calcularMarcaModelo(form),
      })
      onSalvar(atualizado)
    } catch (e) {
      setErro(e.message)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.50)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, padding: '1rem',
    }}>
      <div style={{
        background: 'var(--card-bg)', borderRadius: '22px', border: '1px solid var(--card-border)',
        padding: '2rem', width: '100%', maxWidth: '640px',
        maxHeight: '90vh', overflowY: 'auto',
        boxShadow: '0 8px 40px rgba(0,0,0,0.35)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h2 style={{ margin: 0, border: 'none', padding: 0 }}>Editar Veículo — {veiculo.placa}</h2>
          <button onClick={onFechar} style={{ padding: '6px 14px', fontSize: '12px' }}>Cancelar</button>
        </div>
        <FormVeiculo
          dados={form}
          onChange={setForm}
          onSubmit={salvar}
          salvando={salvando}
          submitLabel="SALVAR ALTERAÇÕES"
        />
        {erro && <div className="badge-err" style={{ marginTop: '12px' }}>{erro}</div>}
      </div>
    </div>
  )
}

function ModalDesmobilizar({ veiculo, onConfirmar, onCancelar }) {
  const [desmobilizando, setDesmobilizando] = useState(false)
  const [erro, setErro] = useState('')

  const confirmar = async () => {
    setDesmobilizando(true)
    setErro('')
    try {
      await api.veiculos.excluir(veiculo.id, 'Desmobilização pelo master')
      onConfirmar(veiculo.id)
    } catch (e) {
      setErro(e.message)
      setDesmobilizando(false)
    }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1100, padding: '1rem',
    }}>
      <div style={{
        background: 'var(--card-bg)', borderRadius: '18px', border: '1px solid var(--card-border)',
        padding: '2rem', width: '100%', maxWidth: '420px',
        boxShadow: '0 8px 40px rgba(0,0,0,0.4)',
      }}>
        <h2 style={{ margin: '0 0 1rem', border: 'none', padding: 0 }}>Desmobilizar veículo</h2>
        <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
          O veículo <strong>{veiculo.placa}</strong> — {veiculo.marca} {veiculo.modelo} será removido da frota ativa. Esta ação pode ser revertida pelo banco de dados.
        </p>
        {erro && <div className="badge-err" style={{ marginBottom: '1rem' }}>{erro}</div>}
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button onClick={onCancelar} style={{ flex: 1 }}>Cancelar</button>
          <button
            onClick={confirmar}
            disabled={desmobilizando}
            style={{
              flex: 1,
              background: '#c0392b', border: '1px solid #c0392b',
              color: '#fff', borderRadius: '10px',
              fontWeight: 'bold', fontSize: '13px', padding: '10px',
              cursor: desmobilizando ? 'not-allowed' : 'pointer',
              opacity: desmobilizando ? 0.7 : 1,
            }}
          >
            {desmobilizando ? 'DESMOBILIZANDO...' : 'CONFIRMAR DESMOBILIZAÇÃO'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default function CadastrarVeiculo() {
  const [veiculos, setVeiculos]         = useState([])
  const [form, setForm]                 = useState(vazio)
  const [mostraCadastro, setMostraCadastro] = useState(false)
  const [editando, setEditando]         = useState(null)
  const [desmobilizando, setDesmobilizando] = useState(null)
  const [loading, setLoading]           = useState(false)
  const [erro, setErro]                 = useState('')
  const [sucesso, setSucesso]           = useState('')

  const carregar = () => api.veiculos.listar().then(setVeiculos).catch(() => {})
  useEffect(() => { carregar() }, [])

  const handleSalvar = async () => {
    setErro(''); setSucesso('')
    if (!form.placa || !form.renavam || !form.chassi || !form.marca || !form.modelo || !form.ano || !form.cor)
      return setErro('Preencha todos os campos obrigatórios.')
    setLoading(true)
    try {
      const novo = await api.veiculos.cadastrar({
        ...form,
        placa: form.placa.toUpperCase(),
        cor: form.cor.toUpperCase(),
        cor_lower: form.cor.charAt(0).toUpperCase() + form.cor.slice(1).toLowerCase(),
        marca_modelo: calcularMarcaModelo(form),
      })
      setVeiculos(prev => [...prev, novo].sort((a, b) => a.placa.localeCompare(b.placa)))
      setSucesso(`Veículo ${novo.placa} cadastrado com sucesso!`)
      setForm(vazio)
      setMostraCadastro(false)
      setTimeout(() => setSucesso(''), 4000)
    } catch (e) {
      setErro(e.message)
    } finally {
      setLoading(false)
    }
  }

  const aoSalvarEdicao = (atualizado) => {
    setVeiculos(vs => vs.map(v => v.id === atualizado.id ? atualizado : v))
    setEditando(null)
    setSucesso(`Veículo ${atualizado.placa} atualizado com sucesso.`)
    setTimeout(() => setSucesso(''), 4000)
  }

  const aoDesmobilizar = (id) => {
    setVeiculos(vs => vs.filter(v => v.id !== id))
    setDesmobilizando(null)
    setSucesso('Veículo desmobilizado com sucesso.')
    setTimeout(() => setSucesso(''), 4000)
  }

  const abrirEdicao = async (v) => {
    try {
      const completo = await api.veiculos.buscar(v.id)
      setEditando(completo)
    } catch {
      setEditando(v)
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h1 style={{ fontSize: '20px', fontWeight: 'normal', letterSpacing: '0.06em', margin: 0, color: 'var(--text-primary)' }}>VEÍCULOS</h1>
        <button
          onClick={() => { setMostraCadastro(v => !v); setErro('') }}
          style={{ fontSize: '12px', padding: '7px 16px', background: mostraCadastro ? 'var(--active-bg)' : undefined, borderColor: mostraCadastro ? '#C9A84C' : undefined }}
        >
          {mostraCadastro ? 'Cancelar' : '+ Novo Veículo'}
        </button>
      </div>

      {sucesso && <div className="badge-ok" style={{ marginBottom: '1rem' }}>{sucesso}</div>}

      {mostraCadastro && (
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <h2>Cadastrar novo veículo</h2>
          <FormVeiculo
            dados={form}
            onChange={setForm}
            onSubmit={handleSalvar}
            salvando={loading}
            submitLabel="Cadastrar veículo"
          />
          {erro && <div className="badge-err" style={{ marginTop: '12px' }}>{erro}</div>}
        </div>
      )}

      <div className="card">
        <h2>Frota ativa ({veiculos.length} veículos)</h2>
        {veiculos.length === 0 ? (
          <p style={{ fontSize: '14px', color: 'var(--text-secondary)', margin: 0 }}>Nenhum veículo cadastrado.</p>
        ) : (
          <table>
            <thead>
              <tr>
                {['Placa', 'Marca/Modelo', 'Ano', 'Cor', ''].map(h => <th key={h}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {veiculos.map(v => (
                <tr key={v.id}>
                  <td style={{ fontWeight: 'bold' }}>{v.placa}</td>
                  <td>{v.marca} {v.modelo}</td>
                  <td>{v.ano}</td>
                  <td>{v.cor}</td>
                  <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <button
                      onClick={() => abrirEdicao(v)}
                      className="btn-amber"
                      style={{ fontSize: '12px', padding: '5px 14px', marginRight: '6px' }}
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => setDesmobilizando(v)}
                      style={{
                        fontSize: '12px', padding: '5px 14px',
                        background: 'transparent', border: '1px solid #c0392b',
                        color: '#c0392b', borderRadius: '8px', cursor: 'pointer',
                      }}
                    >
                      Desmobilizar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {editando && (
        <ModalEditar
          veiculo={editando}
          onSalvar={aoSalvarEdicao}
          onFechar={() => setEditando(null)}
        />
      )}

      {desmobilizando && (
        <ModalDesmobilizar
          veiculo={desmobilizando}
          onConfirmar={aoDesmobilizar}
          onCancelar={() => setDesmobilizando(null)}
        />
      )}
    </div>
  )
}
